import {BaseModel} from "../base";
import {login} from "../../services/login";

class LoginModel extends BaseModel {

    constructor(data) {
        super(data);
    }

    static $companyLogin(company, params, form) {
        return login.companyLogin(company, params, form);
    }

    static $login(form, options) {
        return login.login(form, options);
    }

    static $FBLogin(company, params) {
        return login.FBLogin(company, params);
    }

    static $companyQuery(id) {
        return login.companyQuery(id);
    }

    static $memberQuery(params) {
        return login.memberQuery(params);
    }

    static $ssoLogin(options, data) {
        return login.ssoLogin(options, data);
    }

    static $isLoggedIn() {
        return login.isLoggedIn();
    }

    static $setLogin(member, persist) {
        return login.setLogin(member, persist);
    }

    static $member() {
        return login.member();
    }

    static $checkLogin() {
        return login.checkLogin();
    }

    static $logout() {
        return login.logout();
    }

    static $FBLogout(options) {
        return login.FBLogout(options);
    }

    static $sendPasswordReset(company, params) {
        return login.sendPasswordReset(company, params);
    }

    static $updatePassword(member, params) {
        return login.updatePassword(member, params);
    }
}

export {
    LoginModel
}